import React, { useCallback } from 'react';

// DEPENDENCIES
import { useRecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import SwitchToggle from 'core/tools/SwitchToggle';

// GLOBAL FUNCTIONS
import { apiFetch, makePath } from 'functions';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';
import { checkInventoryStatus } from '../../helpers/checkInventoryStatus';

// MAIN COMPONENT
const WholesaleToggle = () => {

  // HOOKS
  const { record: { is_for_wholesale } = {}, recordID, refetchRecord } = useRecordContext() || {};
      
  // CALLBACKS
  const handleWholeSale = useCallback(
    () => apiFetch({
      method: 'POST',
      endpoint: makePath(ENDPOINTS.inventory.updateWholeSale, recordID),
      params: {
        isForWholeSale: !!is_for_wholesale ? 0 : 1
      },
      loadingMessage: 'Updating Wholesale value',
      successMessage: 'Wholesale value updated successfully',
      onSuccess: () => refetchRecord()
    }),
    [is_for_wholesale, recordID, refetchRecord]
  )

  // RENDER
  return (
    <SwitchToggle
      label="Wholesale"
      onToggle={handleWholeSale}
      active={!!is_for_wholesale}
    />
  );
};

// EXPORT
export default checkInventoryStatus(WholesaleToggle, ['sold', 'preStock', 'order', 'delivered', 'returned'], false);
